import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Get Fee Type.
   * @param feeTypeCategory Fee Type Category
   */
  getFeeType(feeTypeCategory: string): Observable<any> {
    const url = `${environment.expenseApiUrl}/common/findFeeTypeByFeeTypeCategory/${feeTypeCategory}`;
    return this.http.get(url);
  }

  /**
   * Get Facility Options.
   * @param optionType Option Type
   */
  getFacilityOptions(optionType: string): Observable<any> {
    const url = `${environment.expenseApiUrl}/common/findFacilityOptionsByOptionType/${optionType}`;
    return this.http.get(url);
  }

  /**
   * Get Currency Options.
   * @param currency Type
   */
  getCurrencyOptions(): Observable<any> {
    const url = `${environment.wpgApiUrl}/common/getCurrency`;
    return this.http.get(url);
  }
}
